<template>
    <div class="home-dashboard-sidebar">
        <h4 class="home-dashboard-sidebar__title">My Favorites</h4>
        <ul class="home-dashboard-sidebar__list is--favorites">
            <li v-for="project in savedProjects"
                :key="`saved-${project.id}`">
                <a :href="project.is_lite_mode ? `/projects/${project.id}/courses` : `/projects/${project.id}`"
                class="home-dashboard-sidebar__list-item app-card">
                <span class="home-dashboard-sidebar__list-item-client">{{ project.client.name }}</span>
                <span class="home-dashboard-sidebar__list-item-project">{{ project.name }}</span>
                <toggle-favorite :project-id="project.id"></toggle-favorite>
                </a>
            </li>
            <li v-if="!savedProjects.length">
                <p class="home-dashboard-sidebar__empty-list-item element-empty-instructions">You haven't favorited any projects yet.</p>
            </li>
        </ul>
        <h4 class="home-dashboard-sidebar__title">Recently Viewed</h4>
        <ul class="home-dashboard-sidebar__list is--recent">
            <li v-for="project in recentProjects"
                :key="`recent-${project.id}`">
                <a :href="project.is_lite_mode ? `/projects/${project.id}/courses` : `/projects/${project.id}`"
                class="home-dashboard-sidebar__list-item app-card">
                <span class="home-dashboard-sidebar__list-item-client">{{ project.client.name }}</span>
                <span class="home-dashboard-sidebar__list-item-project">{{ project.name }}</span>
                <toggle-favorite :project-id="project.id"></toggle-favorite>
                </a>
            </li>
        </ul>
        <a href="/archive" class="element-button--secondary element-button">View Archived Items</a>
    </div>
</template>

<script>
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'
import ToggleFavorite from './ToggleFavorite'

export default {
    components: { ToggleFavorite },
    computed: {
        ...mapGetters([
            'savedProjects',
            'recentProjects'
        ])
    }
}
</script>
